export function DragIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" fill="none" viewBox="0 0 12 14">
      <path
        fill={color || "currentColor"}
        d="M3.6 3.4a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m0 4.8a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m0 4.8a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m4.8-9.6a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m0 4.8a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m0 4.8a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4"
      />
    </svg>
  );
}
